import { cn } from "@omni/utils/styles";
import { ReactNode } from "react";

import { LabelContextProvider } from "@/components/Price/label/context/label.context";

type Props = {
    position: "left" | "right";
    type: "label" | "ribbon";
    className?: string;
    children: ReactNode;
};

export const Base = ({ position, type, className, children }: Props) => {
    return (
        <LabelContextProvider
            position={position}
            type={type}
        >
            <div
                className={cn(
                    "tw:relative tw:w-fit tw:font-bold tw:flex tw:group/label",
                    {
                        "tw:flex-row": position === "left",
                        "tw:flex-row-reverse": position === "right"
                    },
                    {
                        "tw:before:content-[''] tw:before:absolute tw:before:h-0 tw:before:-bottom-1.5 tw:before:border-y-6 tw:before:border-y-transparent":
                            type === "ribbon",
                        "tw:before:-left-1.5 tw:before:border-r-6 tw:before:border-r-danger-focus":
                            position === "left" && type === "ribbon",
                        "tw:before:-right-1.5 tw:before:border-l-6 tw:before:border-l-danger-focus":
                            position === "right" && type === "ribbon"
                    },
                    {
                        "tw:after:content-[''] tw:after:absolute tw:after:h-full tw:after:w-2 tw:after:bg-danger":
                            type === "ribbon",
                        "tw:after:-left-1.5":
                            position === "left" && type === "ribbon",
                        "tw:after:-right-1.5":
                            position === "right" && type === "ribbon"
                    },
                    className
                )}
            >
                {children}
            </div>
        </LabelContextProvider>
    );
};
